<style scoped>
.dialog-id-row {
  overflow-y: auto;
  display: block;
  height: 500px;
}
</style>

<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">
      Dialoge zur Rundmail (ID: {{ id }})
    </h4>
    <div v-if="dialogs === null" class="d-flex justify-content-around">
      <i class="fas fa-spinner fa-spin fa-10x"></i>
    </div>
    <div class="dialog-id-row" v-else>
      <clickable-id-cell :content="dialogs"></clickable-id-cell>
    </div>
  </v-modal>
</template>

<script lang="babel">
import ClickableIdCell from "@/components/table/ClickableIdCell";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    ClickableIdCell,
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialogs: null
    };
  },
  methods: {
    getDialogs() {
      return this.$http.get("/api/v1/circularMail/dialogs?id="+this.id)
      .then(({ data }) => {
        this.dialogs = data;
      });
    }
  },
  watch: {
    show(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.getDialogs();
      }
    }
  }
};
</script>
